// extracted by mini-css-extract-plugin
export var chevronIcon = "_bc-2";
export var teamName = "_bc-1";
export var teamSwitcherButton = "_bc-0";